<div class="modal-content">
  <div class="modal-header popup-header">
    <h5 class="modal-title" id="locationSettingsTitle">Location Settings</h5>
    <button id="closeLocationSettings" (click)="onCancelSettings()" type="button" class="close" data-dismiss="modal" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row ml-3 mr-3">
      <div class="col-12 p-1">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" name="checkbox" class="custom-control-input" id="setGeofence" (change)="onGeofenceSettingsChange()"
            [checked]="locationSettings.automaticGefoence">
          <label class="custom-control-label" for="setGeofence">Set automatic geofence for operating locations</label>
        </div>
      </div>
      <div class="col-12 p-1">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" name="checkbox" class="custom-control-input" id="defaultLocation"
            (change)="onDefaultVehicleLocationSelectionChange()" [checked]="locationSettings.enableDefaultLocation">
          <label class="custom-control-label" for="defaultLocation">Set default location for new vehicles</label>
        </div>
      </div>
      <div *ngIf="locationSettings.enableDefaultLocation" class="col-12 p-1">
        <select id="loc" (change)="onDefaultLocationSelected($event.target.value)">
          <option value="-1">Select Location</option>
          <option *ngFor="let location of locations; let i = index;" value={{i}} [selected]="location.id == locationSettings.defaultLocationId">
            <span *ngIf="location.address.name">{{location.address.name}}</span>
            <span *ngIf="location.address.name == null">{{location.address.street}}, {{location.address.city}}</span>
          </option>
        </select>
      </div>
      <div class="col-12 p-1">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" name="checkbox" class="custom-control-input" id="provideLocationOutside"
            (change)="onProvideLocationOutsideSelectionChange()" [checked]="locationSettings.outsideVehicleLocation">
          <label class="custom-control-label" for="provideLocationOutside">Provide vehicle’s location outside the
            operating locations</label>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light btn-80" (click)="onCancelSettings()" data-dismiss="modal">CANCEL</button>
    <button type="button" class="btn btn-primary btn-80" (click)="onSaveSettings()">Save</button>
  </div>
</div>